import { HttpClient } from '../HttpClient';
/**
 * * Get Attendance Report Company Filter
 */

export const GetDashboardAccess = async () => {
  try {
    const { data } = await HttpClient.get('api/admin/access');
    return await Promise.resolve(data);
  } catch (err) {
    return Promise.reject(err);
  }
};
